import './mappopup.styles.css'

import { useTranslation } from "react-i18next";
import "../../translations/i18n";

import {Link} from 'react-router-dom'

import Emblem from '../Emblem/emblem.component';

const MapPopup = ({resource, index}) => {
    const id_for_emblem = resource.Type.sort()[0];
    const title_for_emblem = resource.TypeName[0];
    const {t} = useTranslation();
    //console.log(JSON.stringify(resource.Type));
    //console.log(JSON.stringify(resource.TypeName));
    return (
      <div className="map-popup-wrapper" key={index}>
        <div className="map-popup-header-wrapper">
         <Emblem 
                              alt={`${title_for_emblem}`} 
                              kind={`type`}
                              id={id_for_emblem}
                              big={false}
                              noborder={true}
                          />
          <h2>
            <Link to={`/resources/${resource.Id}`}>{resource.Abbreviation }{resource.Abbreviation?':':''} {resource.Name}</Link>
          </h2>
        </div>

        <p>{resource.Description}</p>
        
         {
        false && <ul className="map-popup-ul">
          {
            resource.Laboratory.map((element, index) => (
            <li className="cat-list" key={index}>
              <img
                className='cat-icon'
                src={require('../../assets/img/resources/bl_lab'+resource.LaboratoryId[index]+'.png')} 
              />
              {element}
              </li>))

          }
        </ul>
        }

        {/* {
          resource.Laboratory &&
          <p><strong>Laboratoria:</strong> {resource.Laboratory.join(', ')}</p>
        } */}


        {
          false && resource.Activity &&
          <p className="class-info"><strong>{t('resource.activity')}:</strong> {resource.Activity}</p>
        }
        
        
        {
          resource.Keyword && 
          <p className="class-info"><strong>{t('resource.keyword')}:</strong> {resource.Keyword}</p>
        }

        <p>{resource.Location}</p>
      </div>
    );
}

export default MapPopup